import { createModuleDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';

export const versionDefinitionV0 = createModuleDefinitionVersion({
  label: 'multi-product-calculator',
  description: 'Tool for estimating cost of multiple products together.',
  status: 'active',
  channels: ['web', 'mobile', 'desktop'],
  fieldDefinitions: [
    {
      name: 'restartLabel',
      type: 'string',
      label: 'Restart label',
      defaultValue: 'Restart',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'stepTitle',
      type: 'string',
      label: 'Step title',
      defaultValue: 'STEP {step} OF 2',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'previousButtonLabel',
      type: 'string',
      label: 'Previous button label',
      defaultValue: 'Restart',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'nextButtonLabel',
      type: 'string',
      label: 'next button label',
      defaultValue: 'Next',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'estimateLabel',
      type: 'string',
      label: 'Pricing display estimate label',
      defaultValue: 'Estimate',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'billingCycleLabel',
      type: 'string',
      label: 'Billing cycle label',
      defaultValue: 'Billing cycle',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'monthlyBillingCycleLabel',
      type: 'string',
      label: 'Monthly billing cycle label',
      defaultValue: 'Monthly',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'annuallyBillingCycleLabel',
      type: 'string',
      label: 'Annually billing cycle label',
      defaultValue: 'Annually',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'productsLabel',
      type: 'string',
      label: 'Label for text products in product family name',
      defaultValue: 'products',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'estimatedMonthlyCostLabel',
      type: 'string',
      label: 'Label for estimated monthly cost in price total',
      defaultValue: 'Estimated monthly cost',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'estimatedAnnulaCostLabel',
      type: 'string',
      label: 'Label for estimated annual cost in price total',
      defaultValue: 'Estimated annual cost',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'taxNotIncludedLabel',
      type: 'string',
      label: 'Label for tax not included text in price total',
      defaultValue: 'Tax not included',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'contactSalesLabel',
      type: 'string',
      label: 'Label for contact sales in price total',
      defaultValue: 'Contact sales',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'downloadPdfLabel',
      type: 'string',
      label: 'Label for download pdf in price total',
      defaultValue: 'Download PDF',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'planLabel',
      type: 'string',
      label: 'Label for plan in product container',
      defaultValue: 'Plan',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'numberOfUsersLabel',
      type: 'string',
      label: 'Label for number of users in product container',
      defaultValue: 'Number of users',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'removeLabel',
      type: 'string',
      label: 'Label for removing a product in product container',
      defaultValue: 'Remove',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'freeLabel',
      type: 'string',
      label: 'Label for free in product container',
      defaultValue: 'Free',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'perUserTypeLabel',
      type: 'string',
      label: 'Label for per user type product container',
      defaultValue: 'per user',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'perAgentTypeLabel',
      type: 'string',
      label: 'Label for per agent type product container',
      defaultValue: 'per agent',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'perCreatorTypeLabel',
      type: 'string',
      label: 'Label for per creator type product container',
      defaultValue: 'per creator',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'addMarketplaceAppsLabel',
      type: 'string',
      label: 'Label for adding marketplace apps',
      defaultValue: 'Add Marketplace apps',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'searchMarketplaceAppsLabel',
      type: 'string',
      label: 'Label for searching marketplace apps',
      defaultValue: 'Search Marketplace apps',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'enterAppNameLabel',
      type: 'string',
      label: 'Label for entering marketplace app name placeholder label',
      defaultValue: 'Enter app name',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'noMatchesLabel',
      type: 'string',
      label: 'Label for nothing matches your search label',
      defaultValue: 'Nothing matches your search',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'addProductLabel',
      type: 'string',
      label: 'Add product label',
      defaultValue: 'Add product',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'selectYourProductsLabel',
      type: 'string',
      label: 'Select your products label',
      defaultValue: 'Select your products',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'addProductDetailsLabel',
      type: 'string',
      label: 'Add product details label',
      defaultValue: 'Add product details',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'productLimitErrorMessage1',
      type: 'string',
      label: 'Product limit error of only available monthly',
      defaultValue: 'is only available with monthly billing.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'productLimitErrorMessage2',
      type: 'string',
      label: 'Product limit error of change billing cycle',
      defaultValue:
        'Billed monthly only. Change the billing cycle to monthly to see pricing.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'usersLabel',
      type: 'string',
      label: 'Users label',
      defaultValue: 'users',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'agentsLabel',
      type: 'string',
      label: 'Agents label',
      defaultValue: 'agents',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'creatorsLabel',
      type: 'string',
      label: 'Creators label',
      defaultValue: 'creators',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'numberOfLabel',
      type: 'string',
      label: 'Number of label',
      defaultValue: 'Number of',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'userTierLabel',
      type: 'string',
      label: 'User tier label',
      defaultValue: 'User tier:',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'agentTierLabel',
      type: 'string',
      label: 'Agent tier label',
      defaultValue: 'Agent tier:',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'creatorsTierLabel',
      type: 'string',
      label: 'Creator tier label',
      defaultValue: 'Creator tier:',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'isMaxForLabel',
      type: 'string',
      label: 'Is max for label',
      defaultValue: 'is the max for the',
      i18n: true,
      validations: {
        isRequired: true
      }
    },

    {
      name: 'minUsersLabel',
      type: 'string',
      label: 'Minumum number of users message',
      defaultValue:
        '{minUnits} or more {unitsLabel} is the minimum for the {selectedPlanName} {planLabel}.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'enterpriseAnnualOnlyLabel',
      type: 'string',
      label: 'Enterprise plan is for Annual Billing only',
      defaultValue: '{selectedPlanName} is only available with annual billing.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'enterprisePlanPricingUsersLabel',
      type: 'string',
      label: 'Enterprise plan pricing label for users',
      defaultValue:
        'Enterprise plan pricing is available for {minEnterpriseUnits} or more users.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'enterprisePlanPricingAgentsLabel',
      type: 'string',
      label: 'Enterprise plan pricing label for agents',
      defaultValue:
        'Enterprise plan pricing is available for {minEnterpriseUnits} or more agents.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'enterprisePlanPricingCreatorsLabel',
      type: 'string',
      label: 'Enterprise plan pricing label for creators',
      defaultValue:
        'Enterprise plan pricing is available for {minEnterpriseUnits} or more creators.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },

    {
      name: 'contactSalesTeamLabel',
      type: 'string',
      label: 'Contact our sales team label',
      defaultValue: 'Contact our sales team',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'contactSalesTeamURL',
      type: 'string',
      label: 'Relative URL to contact sales page',
      defaultValue: '/company/contact',
      validations: {
        isRequired: true
      }
    },
    {
      name: 'aboutOptionsLabel',
      type: 'string',
      label: 'About options for this many Label',
      defaultValue: 'about options for this many',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'appLabel',
      type: 'string',
      label: 'App name label',
      defaultValue: 'App',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'appDisclaimerLabel',
      type: 'string',
      label: 'App disclaimer label',
      defaultValue:
        'Apps are billed on the highest user, agent, or creator count across the Jira suite products you entered. Based on what you entered, the apps will be billed for',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'pricingDisclaimerLabel',
      type: 'string',
      label: 'Pricing disclaimer label',
      defaultValue:
        'This estimate isn’t binding for either you or Atlassian. Figures shown here are intended to show an estimation of the final price, not the cost after taxes and other potential charges.',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'estimateDateLabel',
      type: 'string',
      label: 'Estimate Date label',
      defaultValue: 'Estimate Date',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'estimateOnlyLabel',
      type: 'string',
      label: 'Estimate Only label',
      defaultValue: 'Estimate Only',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'questionsLabel',
      type: 'string',
      label: 'Questions label',
      defaultValue: 'Questions?',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'productLabel',
      type: 'string',
      label: 'Product label on pdf',
      defaultValue: 'PRODUCT',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'userTypeInPdfLabel',
      type: 'string',
      label: 'User type label in pdf layout',
      defaultValue: 'USER TYPE',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'pageNumberInPdfLabel',
      type: 'string',
      label: 'page number label in pdf layout',
      defaultValue: 'Page 1 of 1',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'costPerLabel',
      type: 'string',
      label: 'cost per label in pdf layout',
      defaultValue: 'COST PER',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'NumberAndLabel',
      type: 'string',
      label: 'number and label in pdf layout',
      defaultValue: 'NUMBER AND',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'tierLabelInPdf',
      type: 'string',
      label: 'tier label in pdf layout',
      defaultValue: 'TIER',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'appCardUnexpectedError',
      type: 'string',
      label: 'error message for app-card error',
      defaultValue: 'An unexpected error occurred',
      i18n: true,
      validations: {
        isRequired: true
      }
    },
    {
      name: 'appCardPricingDataMissingError',
      type: 'string',
      label: 'error message for app-card missing pricing data',
      defaultValue:
        'The selected billing cycle is unsupported for this app. Please switch to a different billing cycle and re-add the app.',
      i18n: true,
      validations: {
        isRequired: true
      }
    }
  ]
});
